import { ExclamationTriangleIcon } from "@heroicons/react/20/solid";

const message = process.env.REACT_APP_WARNING_MESSAGE?.trim();

export default function WarningMessage() {
  if (!message) {
    return null;
  }

  return (
    <div className="border-b border-yellow-200 bg-yellow-50" role="status">
      <div className="mx-auto flex max-w-7xl items-center justify-center gap-2 px-4 py-3 sm:px-6 lg:px-8">
        <ExclamationTriangleIcon
          className="h-5 w-5 flex-shrink-0 text-yellow-400"
          aria-hidden="true"
        />
        <p className="text-center text-sm text-yellow-800">{message}</p>
      </div>
    </div>
  );
}
